import React, { useEffect, useState } from "react";
import {
    DataGrid,
    GridColDef,
    GridToolbar,
} from "@mui/x-data-grid";
import axios from "axios";
import HOST_URL from "../../../utils/Url";
import Card from "@mui/material/Card";
import {
    Grid,
    Box,
    Button,
    Divider,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import { useNavigate, useLocation } from "react-router-dom";
import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import DeleteIcon from "@mui/icons-material/Delete";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import CircularProgress from "@mui/material/CircularProgress";
import api from "../../../utils/Url";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FileDetailSwipeableDrawer from "./FileDetailSwipeableDrawer";
// import SwipeableTemporaryDrawer from "./FileDetailSwipeableDrawer";


interface MenuPermission {
    isAdd: boolean;
    isEdit: boolean;
    isPrint: boolean;
    isDel: boolean;
}

export default function FileDetail() {
    const [zones, setZones] = useState([]);
    const [columns, setColumns] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();
    const [permissionData, setPermissionData] = useState<MenuPermission>({
        isAdd: false,
        isEdit: false,
        isPrint: false,
        isDel: false,
    });

    const [fileDetailData, setFileDetailData] = useState<any>(null);
    const [fileDetailRecords, setFileDetailRecords] = useState<any>(null);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [keywordParams, setKeywodParams] = useState("");

    const [fieldValue, setFieldValue] = useState({
        accNo: "",
        title: "",
        author: "",
        location: "",
        classNo: "",
    });


    let navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        const dataString = localStorage.getItem("userdata");
        if (dataString) {
            const data = JSON.parse(dataString);
            if (data && data.length > 0) {
                const userPermissionData = data[0]?.userPermission;
                if (userPermissionData && userPermissionData.length > 0) {
                    const menudata = userPermissionData[0]?.parentMenu;
                    for (let index = 0; index < menudata.length; index++) {
                        const childMenudata = menudata[index]?.childMenu;
                        const pathrow = childMenudata.find(
                            (x: any) => x.path === location.pathname
                        );
                        console.log("data", pathrow);
                        if (pathrow) {
                            setPermissionData(pathrow);
                            fetchZonesData(-1);
                        }
                    }
                }
            }
        }
    }, []);
    // }, [isLoading]);
    const routeChangeAdd = () => {
        let path = `/Library/FileDetailAdd`;
        navigate(path);
    };

    // const handleSwitchChange = (
    //     event: React.ChangeEvent<HTMLInputElement>,
    //     value: any
    // ) => {
    //     console.log(value)
    //     const collectData = {
    //         fileID: value.id,
    //         fileName: value.fileName,
    //         synopsis: value.synopsis,
    //         remark: value.remark,
    //         isActive: event.target.checked,
    //         userID: -1,
    //         sortOrder: 0,
    //     };
    //     axios
    //         .post(HOST_URL.HOST_URL2 + `FileDetail/AddUpdateFileDetails`, collectData)
    //         .then((response) => {
    //             if (response.data.isSuccess) {
    //                 toast.success(response.data.mesg);
    //                 fetchZonesData();
    //             } else {
    //                 toast.error(response.data.mesg);
    //             }
    //         });
    // };
    const routeChangeEdit = (row: any) => {
        let path = `/Library/FileDetailEdit`;
        navigate(path, {
            state: row,
        });
    };

    let delete_id = "";

    const accept = () => {
        const collectData = {
            fileID: delete_id
        };
        console.log("collectData " + JSON.stringify(collectData));
        api
            .delete(`FileDetail/DeleteFileDetails`, { data: collectData })
            .then((response) => {
                if (response.data.isSuccess) {
                    toast.success(response.data.mesg);
                } else {
                    toast.error(response.data.mesg);
                }
                //fetchZonesData();
            });
    };

    const reject = () => {
        // toast.warn({summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        toast.warn("Rejected: You have rejected", { autoClose: 3000 });
    };

    const handledeleteClick = (del_id: any) => {
        // console.log(del_id + " del_id ");
        delete_id = del_id;
        confirmDialog({
            message: t("text.DoYouWantToDeleteThisRecord"),
            header: t("text.DeleteConfirmation"),
            icon: "pi pi-info-circle",
            acceptClassName: "p=-button-danger",
            accept,
            reject,
        });
    };


    const getFileDetailsRecords = async (id: any) => {
        // setIsReportLoading(true);
        const collectData = {
            fileID: id,
            fileType: -1,
            fileGroup: -1,
            fileCategory: -1,
            fileClass: -1,
            fileSubject: -1,
        }
        console.log("collectData", collectData);

        const response = await api.post(
            `FileDetail/GetFileDetails`,
            collectData
        );
        console.log("collectData", response.data.data);
        setFileDetailData(response.data.data[0]["fileNo"] + " - " + response.data.data[0]["fileName"])
        setFileDetailRecords(response.data.data);
        setDrawerOpen(true);
    }
    const fetchDataTitlewise = async (id: any) => {
        try {
            const response = await api
                .get('AssigningRfid/GetBookAccDetailsSearchByTitle', { headers: { keyword: id } })
            const data = response.data.data;
            const zonesWithIds = data.map((emp: any, index: any) => ({
                ...emp,
                id: index + 1,
                accNo: emp.accNo || "--",
                title: emp.title || "--",
                author: emp.author || "--",
                location: emp.location || "--",
                department: emp.department || "--",
            }));
            setZones(zonesWithIds);
            setIsLoading(false);
            if (data.length > 0) {
                const columns: GridColDef[] = [
                    {
                        field: "id",
                        headerName: t("text.SrNo"),
                        flex: 0.3,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 60
                    },
                    {
                        field: "accNo",
                        headerName: "Acc. No.",
                        flex: .6,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 80
                    },
                    {
                        field: "title",
                        headerName: "Book Name",
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 200
                    },
                    {
                        field: "author",
                        headerName: "Author",
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 160
                    },
                    {
                        field: "location",
                        headerName: "Location",
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 200
                    },
                    {
                        field: "classNo",
                        headerName: "Class No",
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 200
                    },

                ];
                setColumns(columns as any);
            }


        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }
    const fetchauthorwise = async (id: any) => {
        try {
            const response = await api
                .get('AssigningRfid/GetBookAccDetailsSearchByAuther', { headers: { keyword: id } })
            const data = response.data.data;
            const zonesWithIds = data.map((emp: any, index: any) => ({
                ...emp,
                id: index + 1,
                accNo: emp.accNo || "--",
                title: emp.title || "--",
                author: emp.author || "--",
                location: emp.location || "--",
                department: emp.department || "--",
            }));
            setZones(zonesWithIds);
            setIsLoading(false);
            if (data.length > 0) {
                const columns: GridColDef[] = [
                    {
                        field: "id",
                        headerName: t("text.SrNo"),
                        flex: 0.3,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 60
                    },
                    {
                        field: "accNo",
                        headerName: "Acc. No.",
                        flex: .6,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 80
                    },
                    {
                        field: "title",
                        headerName: "Book Name",
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 200
                    },
                    {
                        field: "author",
                        headerName: "Author",
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 160
                    },
                    {
                        field: "location",
                        headerName: "Location",
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 200
                    },
                    {
                        field: "classNo",
                        headerName: "Class No",
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 200
                    },

                ];
                setColumns(columns as any);
            }


        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }

    const fetchLocationwise = async (id: any) => {
        try {
            const response = await api
                .get('AssigningRfid/GetBookAccDetailsSearchByLocation', { headers: { keyword: id } })
            const data = response.data.data;
            const zonesWithIds = data.map((emp: any, index: any) => ({
                ...emp,
                id: index + 1,
                accNo: emp.accNo || "--",
                title: emp.title || "--",
                author: emp.author || "--",
                location: emp.location || "--",
                department: emp.department || "--",
            }));
            setZones(zonesWithIds);
            setIsLoading(false);
            if (data.length > 0) {
                const columns: GridColDef[] = [
                    {
                        field: "id",
                        headerName: t("text.SrNo"),
                        flex: 0.3,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 60
                    },
                    {
                        field: "accNo",
                        headerName: "Acc. No.",
                        flex: .6,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 80
                    },
                    {
                        field: "title",
                        headerName: "Book Name",
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 200
                    },
                    {
                        field: "author",
                        headerName: "Author",
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 160
                    },
                    {
                        field: "location",
                        headerName: "Location",
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 200
                    },
                    {
                        field: "classNo",
                        headerName: "Class No",
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 200
                    },

                ];
                setColumns(columns as any);
            }


        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }


    const fetchClassWise = async (id: any) => {
        try {
            const response = await api
                .get('AssigningRfid/GetBookAccDetailsSearchByClassNo', { headers: { keyword: id } })
            const data = response.data.data;
            const zonesWithIds = data.map((emp: any, index: any) => ({
                ...emp,
                id: index + 1,
                accNo: emp.accNo || "--",
                title: emp.title || "--",
                author: emp.author || "--",
                location: emp.location || "--",
                department: emp.department || "--",
            }));
            setZones(zonesWithIds);
            setIsLoading(false);
            if (data.length > 0) {
                const columns: GridColDef[] = [
                    {
                        field: "id",
                        headerName: t("text.SrNo"),
                        flex: 0.3,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 60
                    },
                    {
                        field: "accNo",
                        headerName: "Acc. No.",
                        flex: .6,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 80
                    },
                    {
                        field: "title",
                        headerName: "Book Name",
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 200
                    },
                    {
                        field: "author",
                        headerName: "Author",
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 160
                    },
                    {
                        field: "location",
                        headerName: "Location",
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 200
                    },
                    {
                        field: "classNo",
                        headerName: "Class No",
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 200
                    },

                ];
                setColumns(columns as any);
            }


        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }


    const fetchZonesData = async (id: any) => {
        try {
            const response = await api
                .get(`AssigningRfid/GetBookAccDetails`, { headers: { keyword: id } })
            const data = response.data.data;
            const zonesWithIds = data.map((emp: any, index: any) => ({
                ...emp,
                id: index + 1,
                accNo: emp.accNo || "--",
                title: emp.title || "--",
                author: emp.author || "--",
                location: emp.location || "--",
                department: emp.department || "--",
            }));


            setZones(zonesWithIds);
            setIsLoading(false);

            if (data.length > 0) {
                const columns: GridColDef[] = [
                    {
                        field: "id",
                        headerName: t("text.SrNo"),
                        flex: .3,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 60
                    },
                    {
                        field: "accNo",
                        headerName: "Acc. No.",
                        flex: .6,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 80
                    },
                    {
                        field: "title",
                        headerName: "Book Name",
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 200
                    },
                    {
                        field: "author",
                        headerName: "Author",
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 160
                    },
                    {
                        field: "location",
                        headerName: "Location",
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 200
                    },



                    {
                        field: "classNo",
                        headerName: "Class No.",
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        minWidth: 200
                    },

                ];
                setColumns(columns as any);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            // setLoading(false);
        }
    };

    const adjustedColumns = columns.map((column: any) => ({
        ...column,
    }));


    return (
        <>
            <Card
                style={{
                    width: "100%",
                    // height: "100%",
                    backgroundColor: "#E9FDEE",
                    // border: ".5px solid #FF7722 ",
                    marginTop: "3vh"
                }}
            >
                <Paper
                    sx={{
                        width: "100%",
                        overflow: "hidden",
                        "& .MuiDataGrid-colCell": {
                            backgroundColor: "#2B4593",
                            color: "#fff",
                            fontSize: 17,
                            fontWeight: 900
                        },
                    }}
                    style={{ padding: "10px", }}
                >
                    <ConfirmDialog />

                    <Typography
                        gutterBottom
                        variant="h5"
                        component="div"
                        sx={{ padding: "20px" }}
                        align="left"
                    >
                        {t("text.FileDetails")}
                    </Typography>
                    <Divider />

                    <Box height={10} />



                    <Grid container spacing={2} sx={{ padding: 2 }}>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                placeholder={t("text.SearchByAccNo")}
                                size="small"
                                fullWidth
                                value={fieldValue.accNo}
                                onChange={(e: any) => {
                                    setFieldValue({ ...fieldValue, accNo: e.target.value });
                                    let checkValue = e.target.value;
                                    setKeywodParams(e.target.value)
                                    if (checkValue.length >= 1 || e.target.value == undefined) {
                                        fetchZonesData(checkValue)
                                    }
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                placeholder={t("text.SearchByTitle")}
                                size="small"
                                fullWidth
                                value={fieldValue.title}
                                onChange={(e: any) => {
                                    setFieldValue({ ...fieldValue, title: e.target.value });
                                    let checkValue = e.target.value;
                                    setKeywodParams(e.target.value)
                                    if (checkValue.length >= 1 || e.target.value == undefined) {
                                        fetchDataTitlewise(checkValue)
                                    }
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                placeholder={t("text.SearchByAuthor")}
                                size="small"
                                fullWidth
                                value={fieldValue.author}
                                onChange={(e: any) => {
                                    setFieldValue({ ...fieldValue, author: e.target.value });
                                    let checkValue = e.target.value;
                                    setKeywodParams(e.target.value)
                                    if (checkValue.length >= 1 || e.target.value == undefined) {
                                        fetchauthorwise(checkValue)
                                    }
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                placeholder={t("text.SearchByLocation")}
                                size="small"
                                fullWidth
                                value={fieldValue.location}
                                onChange={(e: any) => {
                                    setFieldValue({ ...fieldValue, location: e.target.value });
                                    let checkValue = e.target.value;
                                    setKeywodParams(e.target.value)
                                    if (checkValue.length >= 1 || e.target.value == undefined) {
                                        fetchLocationwise(checkValue)
                                    }
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                placeholder={t("text.SearchByClassNo")}
                                size="small"
                                fullWidth
                                value={fieldValue.classNo}
                                onChange={(e: any) => {
                                    setFieldValue({ ...fieldValue, classNo: e.target.value });
                                    let checkValue = e.target.value;
                                    setKeywodParams(e.target.value)
                                    if (checkValue.length >= 1 || e.target.value == undefined) {
                                        fetchClassWise(checkValue)
                                    }
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                            <Button
                                onClick={() => {
                                    setFieldValue({
                                        accNo: "",
                                        title: "",
                                        author: "",
                                        location: "",
                                        classNo: "",
                                    });
                                    fetchZonesData("");
                                }}
                                variant="contained"
                                size="large"
                                sx={{ backgroundColor: "#f43f5e", color: "#fff", "&:hover": { backgroundColor: "#ff0000" } }}
                            >
                                {t("text.reset")}
                            </Button>
                        </Grid>
                    </Grid>

                    {/*permissionData?.isAdd == true && ( */}
                    {/* <Button
                            onClick={routeChangeAdd}
                            variant="contained"
                            endIcon={<AddCircleIcon />}
                            size="large"
                        >
                          {t("text.Add")}
                        </Button> */}
                    {/*)} */}

                    {/*{permissionData?.isPrint == true ? (
              <Button variant="contained" endIcon={<PrintIcon />} size="large">
                {t("text.print")}
              </Button>
            ) : (
              ""
            )} */}



                    <FileDetailSwipeableDrawer
                        open={drawerOpen}
                        onClose={() => setDrawerOpen(false)}
                        title={`# ${fileDetailData}    file Details`}
                        userData={fileDetailRecords}
                    />

                    {isLoading ? (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <CircularProgress />
                        </div>
                    ) : (
                        <Box>
                            <br />
                            <div style={{ width: "100%", backgroundColor: "#FFFFFF" }}>
                                <DataGrid
                                    rows={zones}
                                    columns={adjustedColumns}
                                    autoHeight
                                    slots={{
                                        toolbar: GridToolbar,
                                    }}
                                    rowSpacingType="border"
                                    pagination={true}
                                    pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
                                        value: size,
                                        label: `${size}`,
                                    }))}
                                    initialState={{
                                        pagination: { paginationModel: { pageSize: 5 } },
                                    }}
                                    slotProps={{
                                        toolbar: {
                                            showQuickFilter: true,
                                        },
                                    }}
                                />
                            </div>

                        </Box>)}
                </Paper>
            </Card>
            <ToastApp />

        </>
    );
}
